import {
  type ChangePasswordRequest,
  type EnableTwoFactorRequest,
  type LoginRequest,
  type LoginResponse,
  LoginResponseSchema,
  type LoginSuccessResponse,
  LoginSuccessResponseSchema,
  type ResetTwoFactorRequest,
  type SessionResponse,
  SessionResponseSchema,
  type SetupTwoFactorResponse,
  SetupTwoFactorResponseSchema,
  type VerifyMfaRequest,
} from '@ctms/contracts';

import { apiClient } from '../../api/client.js';
import { API_PATHS } from '../../api/paths.js';

export const authApi = {
  async login(request: LoginRequest): Promise<LoginResponse> {
    const raw: unknown = await apiClient
      .post(API_PATHS.auth.login, { json: request })
      .json();
    return LoginResponseSchema.parse(raw);
  },

  async verifyMfa(request: VerifyMfaRequest): Promise<LoginSuccessResponse> {
    const raw: unknown = await apiClient
      .post(API_PATHS.auth.verifyMfa, { json: request })
      .json();
    return LoginSuccessResponseSchema.parse(raw);
  },

  async fetchSession(): Promise<SessionResponse> {
    const raw: unknown = await apiClient.get(API_PATHS.auth.me).json();
    return SessionResponseSchema.parse(raw);
  },

  async resetMfa(userId: number): Promise<{ success: true }> {
    const payload: ResetTwoFactorRequest = { userId };
    const raw: unknown = await apiClient
      .post(API_PATHS.auth.resetMfa, { json: payload })
      .json();
    return raw as { success: true };
  },

  async setupMfa(): Promise<SetupTwoFactorResponse> {
    const raw: unknown = await apiClient
      .post(API_PATHS.auth.setupMfa)
      .json();
    return SetupTwoFactorResponseSchema.parse(raw);
  },

  async enableMfa(code: string): Promise<{ success: true }> {
    const payload: EnableTwoFactorRequest = { code };
    const raw: unknown = await apiClient
      .post(API_PATHS.auth.enableMfa, { json: payload })
      .json();
    return raw as { success: true };
  },

  async changePassword(request: ChangePasswordRequest): Promise<{ success: true }> {
    const raw: unknown = await apiClient
      .post(API_PATHS.auth.changePassword, { json: request })
      .json();
    return raw as { success: true };
  },
};
